import { useEffect, useState } from 'react';

const navItems = [
  { label: '首页', href: '#top' },
  { label: '黑料存档', href: '#archive' },
  { label: '黑料合集', href: '#compilation' },
  { label: '黑料整理', href: '#topics' },
  { label: '黑料大全', href: '#ranking' },
  { label: '互动区', href: '#discussion' },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="hidden bg-primary-950 text-background-100 md:block">
        <div className="flex items-center justify-between px-4 py-1.5 text-xs md:px-6 lg:px-10">
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1.5">
              <i className="ri-calendar-line"></i>
              2026 年 09 月 10 日 星期四
            </span>
            <span className="flex items-center gap-1.5 text-background-200/80">
              <i className="ri-database-2-line"></i>
              当前收录 12,684 条存档记录
            </span>
          </div>
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1.5">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-400 animate-pulse-dot"></span>
              存档服务正常
            </span>
            <a href="#discussion" className="cursor-pointer transition-colors hover:text-accent-300">
              留言互动
            </a>
          </div>
        </div>
      </div>

      <div
        className={`w-full border-b transition-all duration-300 ${
          scrolled
            ? 'border-background-200 bg-background-50/95 backdrop-blur-md'
            : 'border-transparent bg-background-50/80 backdrop-blur-sm'
        }`}
      >
        <div className="flex items-center gap-4 px-4 py-3 md:px-6 lg:px-10">
          <h1 className="shrink-0">
            <a href="#top" className="flex cursor-pointer items-baseline gap-2">
              <span className="font-logo text-2xl leading-none text-primary-600 md:text-3xl">
                黑吃瓜网
              </span>
              <span className="hidden text-xs text-foreground-500 lg:inline">
                黑料存档 · 一次看全
              </span>
            </a>
          </h1>

          <nav className="hidden flex-1 items-center justify-center gap-1 md:flex">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2 md:ml-0">
            <div className="hidden items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 lg:flex">
              <i className="ri-search-line text-base text-foreground-500"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索黑料存档 / 合集"
                className="w-40 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none"
              />
            </div>
            <a
              href="#compilation"
              className="hidden cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              <i className="ri-archive-line"></i>
              进入存档
            </a>
            <button
              type="button"
              aria-label="展开菜单"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-700 md:hidden"
            >
              <i className={menuOpen ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'}></i>
            </button>
          </div>
        </div>

        {menuOpen ? (
          <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
            <nav className="flex flex-col">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="cursor-pointer rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
        ) : null}
      </div>
    </header>
  );
}